var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-tabs",
        {
          staticStyle: { "margin-top": "8px" },
          attrs: { type: "card" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeTabName,
            callback: function($$v) {
              _vm.activeTabName = $$v
            },
            expression: "activeTabName"
          }
        },
        [
          _c(
            "el-tab-pane",
            {
              attrs: {
                label: _vm.$t("CargoMsg.Cargo_MaritimeIdentification"),
                name: "ocrSe"
              }
            },
            [
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "padding-left": "8px",
                    "padding-top": "8px"
                  }
                },
                [
                  !_vm.isPlatform
                    ? _c(
                        "div",
                        { staticClass: "filters" },
                        [
                          _c(
                            "el-form",
                            {
                              attrs: {
                                inline: true,
                                "label-width": "100px",
                                "label-position": "right"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "el-form-item-wrapper" },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        "label-width": "50px",
                                        label: _vm.$t(
                                          "SystemMaintenance.Branch"
                                        )
                                      }
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          attrs: { no: "1" },
                                          on: {
                                            change: function($event) {
                                              return _vm.changeBranch()
                                            }
                                          },
                                          model: {
                                            value: _vm.branchId,
                                            callback: function($$v) {
                                              _vm.branchId = $$v
                                            },
                                            expression: "branchId"
                                          }
                                        },
                                        _vm._l(_vm.currentOfficeList, function(
                                          office
                                        ) {
                                          return _c("el-option", {
                                            key: office.officeId,
                                            attrs: {
                                              value: office.officeId,
                                              label: office.code
                                            }
                                          })
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-form-item",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.branchId !== 1,
                                          expression: "branchId!==1"
                                        }
                                      ],
                                      attrs: {
                                        label: _vm.$t(
                                          "SystemMaintenance.ApplyTheHeadOfficesSettings"
                                        )
                                      }
                                    },
                                    [
                                      _c("el-checkbox", {
                                        attrs: { no: "2" },
                                        on: { change: _vm.applyHq },
                                        model: {
                                          value: _vm.ifHq,
                                          callback: function($$v) {
                                            _vm.ifHq = $$v
                                          },
                                          expression: "ifHq"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ]
                          ),
                          _c("br")
                        ],
                        1
                      )
                    : _vm._e(),
                  _c("div", { staticClass: "show-right" }, [
                    _c(
                      "div",
                      {
                        staticClass: "main-content left",
                        staticStyle: {
                          "margin-top": "20px",
                          "margin-left": "30px"
                        }
                      },
                      [
                        _c(
                          "el-form",
                          {
                            attrs: {
                              inline: true,
                              "label-width": "100px",
                              "label-position": "right"
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { "margin-bottom": "5px" } },
                              [
                                _vm.otherField.ifDefaultConfig &&
                                !_vm.isPlatform
                                  ? _c("span", {
                                      staticStyle: {
                                        "font-size": "14px",
                                        color: "#acacac"
                                      },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("CargoMsg.Cargo_OcrSetTip")
                                        )
                                      }
                                    })
                                  : _vm._e()
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "el-form-item-wrapper",
                                staticStyle: {
                                  "padding-top": "10px",
                                  "padding-bottom": "10px"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-size": "18px",
                                      "padding-right": "95px"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "CargoMsg.Cargo_ApplicationIdentificationType"
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: { "label-width": "200px", label: "" }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticStyle: { width: "200px" },
                                        attrs: { no: "1" },
                                        on: { change: _vm.refresh },
                                        model: {
                                          value: _vm.useCase,
                                          callback: function($$v) {
                                            _vm.useCase = $$v
                                          },
                                          expression: "useCase"
                                        }
                                      },
                                      _vm._l(_vm.typeList(), function(
                                        item,
                                        index
                                      ) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            label: _vm.$getLangColumn(item),
                                            value: item.code
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]
                        ),
                        _c("div", { staticStyle: { width: "400px" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "flex-direction": "column",
                                "flex-wrap": "wrap",
                                "max-height": "700px"
                              }
                            },
                            _vm._l(_vm.fieldDefineList, function(item) {
                              return _c(
                                "div",
                                {
                                  key: item.code,
                                  staticStyle: { padding: "7px", width: "33%" }
                                },
                                [
                                  _c(
                                    "el-checkbox",
                                    {
                                      attrs: {
                                        disabled: item.disabled || _vm.readonly,
                                        no: item.code
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.fieldCheckboxHandle(item)
                                        }
                                      },
                                      model: {
                                        value:
                                          _vm.otherField.fieldSelectedVo[
                                            item.code
                                          ],
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.otherField.fieldSelectedVo,
                                            item.code,
                                            $$v
                                          )
                                        },
                                        expression:
                                          "otherField.fieldSelectedVo[item.code]"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.isZh
                                            ? item.chineseName
                                            : item.englishName
                                        )
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            }),
                            0
                          )
                        ])
                      ],
                      1
                    ),
                    _c("div", { staticClass: "division" }),
                    _c(
                      "div",
                      {
                        staticClass: "middle",
                        staticStyle: {
                          "margin-top": "20px",
                          "margin-left": "30px"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "padding-top": "10px",
                              "padding-bottom": "10px"
                            }
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "18px",
                                  "margin-right": "50px"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "CargoMsg.Cargo_BookNoteFieldAndSort"
                                    )
                                  )
                                )
                              ]
                            ),
                            _vm.readonly
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      disabled: _vm.ifHq,
                                      type: "primary",
                                      no: "3"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.edit()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("common.btn.edit")) +
                                        " "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            !_vm.readonly
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      disabled: _vm.ifHq,
                                      type: "primary",
                                      no: "4"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.cancel()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("common.btn.cancel")) +
                                        " "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            !_vm.readonly
                              ? _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "5px" },
                                    attrs: {
                                      disabled: _vm.ifHq,
                                      type: "primary",
                                      no: "5"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.saveOcrField(false)
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("common.btn.save")) +
                                        " "
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm.readonly
                              ? _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "5px" },
                                    attrs: {
                                      disabled: _vm.ifHq,
                                      type: "primary",
                                      no: "checkSetting"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.checkSetting()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t("CargoMsg.Cargo_CheckSetting")
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              : _vm._e()
                          ],
                          1
                        ),
                        _c(
                          "draggable",
                          {
                            staticStyle: { width: "100%", cursor: "pointer" },
                            attrs: { disabled: _vm.readonly, animation: "300" },
                            on: { update: _vm.onDragUpdate },
                            model: {
                              value: _vm.otherField.ocrOtherFieldDetails,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.otherField,
                                  "ocrOtherFieldDetails",
                                  $$v
                                )
                              },
                              expression: "otherField.ocrOtherFieldDetails"
                            }
                          },
                          [
                            _c(
                              "transition-group",
                              {
                                staticStyle: {
                                  width: "100%",
                                  display: "flex",
                                  "flex-direction": "column",
                                  "flex-wrap": "wrap",
                                  "max-height": "710px",
                                  "align-content": "flex-start"
                                }
                              },
                              _vm._l(
                                _vm.otherField.ocrOtherFieldDetails,
                                function(item, index) {
                                  return _c(
                                    "div",
                                    {
                                      key: item.code,
                                      staticClass: "item",
                                      staticStyle: {
                                        padding: "9px",
                                        width: "24%",
                                        border: "1px solid #f5f5f5",
                                        "margin-top": "-1px",
                                        "margin-right": "-1px"
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "justify-content": "space-between"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.isZh
                                                  ? _vm.fieldDefineMap[
                                                      item.code
                                                    ].chineseName
                                                  : _vm.fieldDefineMap[
                                                      item.code
                                                    ].englishName
                                              ) +
                                              " "
                                          ),
                                          _c("img", {
                                            staticStyle: {
                                              "align-self": "center",
                                              "margin-left": "5px",
                                              width: "11px",
                                              height: "11px"
                                            },
                                            attrs: { src: "/static/move.svg" }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                }
                              ),
                              0
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c("div", { staticClass: "division" }),
                    _c("div", { staticClass: "right" }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-top": "20px",
                            "margin-left": "30px"
                          }
                        },
                        [
                          _c(
                            "div",
                            [
                              _c(
                                "span",
                                { staticStyle: { "font-size": "18px" } },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("SeaExport.ocrTextMapper"))
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-left": "100px" },
                                  attrs: {
                                    type: "primary",
                                    disabled: _vm.ifHq,
                                    no: "8"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.addMapper()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("SeaExport.Add")) + " "
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-left": "5px" },
                                  attrs: {
                                    type: "primary",
                                    disabled: _vm.ifHq,
                                    no: "9"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.editMapper()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.$t("SeaExport.Edit")) + " "
                                  )
                                ]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "margin-left": "5px" },
                                  attrs: {
                                    type: "danger",
                                    disabled: _vm.ifHq,
                                    no: "10"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.deleteMapper()
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("SeaExport.Delete")) +
                                      " "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                width: "600px",
                                "margin-top": "30px"
                              }
                            },
                            [
                              _c("cargo-ag-grid", {
                                staticStyle: {
                                  width: "100%",
                                  height: "400px",
                                  "margin-top": "10px"
                                },
                                attrs: {
                                  "show-side-bar": false,
                                  "grid-options": _vm.gridOptions,
                                  "column-defs": _vm.columnDefs,
                                  "row-data": _vm.textRowData
                                },
                                on: {
                                  gridReady: function(params) {
                                    _vm.gridApi = params.api
                                  }
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ])
                  ])
                ]
              )
            ]
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.mapperDialog.visible,
            title: _vm.mapperDialog.title,
            width: "400px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.mapperDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "110px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("CargoMsg.Cargo_Type") } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "240px" },
                          attrs: { no: "11" },
                          model: {
                            value: _vm.mapperDialog.form.type,
                            callback: function($$v) {
                              _vm.$set(_vm.mapperDialog.form, "type", $$v)
                            },
                            expression: "mapperDialog.form.type"
                          }
                        },
                        _vm._l(_vm.SystemConstants.OCR_MAPPER_TYPES, function(
                          item,
                          index
                        ) {
                          return _c("el-option", {
                            key: index,
                            attrs: {
                              label: _vm.isZh
                                ? item.chineseName
                                : item.englishName,
                              value: item.code
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.IdentifyingText"),
                        required: ""
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "240px" },
                        attrs: { no: "12" },
                        model: {
                          value: _vm.mapperDialog.form.oldText,
                          callback: function($$v) {
                            _vm.$set(_vm.mapperDialog.form, "oldText", $$v)
                          },
                          expression: "mapperDialog.form.oldText"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.mappedValue"),
                        required: ""
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "240px" },
                        attrs: { no: "13" },
                        model: {
                          value: _vm.mapperDialog.form.newText,
                          callback: function($$v) {
                            _vm.$set(_vm.mapperDialog.form, "newText", $$v)
                          },
                          expression: "mapperDialog.form.newText"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "14" },
                  on: { click: _vm.saveMapper }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "15" },
                  on: {
                    click: function($event) {
                      _vm.mapperDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _vm.ocrFieldCheckConfigDialog.visible
        ? _c("ocr-field-check-config-dialog", {
            attrs: {
              visible: _vm.ocrFieldCheckConfigDialog.visible,
              "other-field": _vm.otherField,
              "field-define-list": _vm.fieldDefineList,
              "field-define-map": _vm.fieldDefineMap
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(
                  _vm.ocrFieldCheckConfigDialog,
                  "visible",
                  $event
                )
              },
              cancel: function(item) {
                return (_vm.otherField = item)
              },
              saveSuccess: _vm.initField
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }